import React from "react";
import SurveyAnswerPreview from "./SurveyAnswerPreview";
import { surveyPreviewIcons } from "./surveyPreviewAssets";

const previewText = (value, fallback) => String(value || "").trim() || fallback;

const SurveyQuestionPreview = ({ question, index, total, selectedIds, onSelect }) => {
  const progress = total ? ((index + 1) / total) * 100 : 0;
  const iconKey = question.type === "rating" ? `rating_${question.ratingStyle || "stars"}` : question.type;
  return <div className="survey-mobile-screen survey-mobile-question-screen">
    <div className="survey-mobile-status-bar"><span>11:10</span><span>● ◢ ▮</span></div>
    <div className="survey-mobile-question-header"><span className="survey-mobile-back">‹</span><div className="survey-mobile-progress"><span style={{ width: `${progress}%` }} /></div><span className="survey-mobile-progress-count">{index + 1} / {total}</span></div>
    <div className="survey-mobile-question-content"><div className="survey-mobile-question-icon"><img src={surveyPreviewIcons[iconKey]} alt="" className="survey-mobile-question-icon-image" /></div><h2>{previewText(question.question, "Your question will appear here")}</h2>{question.description && <p>{question.description}</p>}<div className="survey-mobile-answer-area"><SurveyAnswerPreview question={question} selectedIds={selectedIds} onSelect={onSelect} /></div></div>
    <div className="survey-mobile-question-footer"><button type="button" tabIndex="-1">{question.required ? "Next" : "Skip"}</button></div>
  </div>;
};

export default SurveyQuestionPreview;
